import { Button } from "@/components/ui/button";
import { CircleCheck, Home, Link2Off } from "lucide-react";
import { usePoContractsUpdateFlow } from "../../context/use-po-contracts-update-flow";
import { Card } from "@/components/ui/card";

export const PoContractsUpdateResult = () => {
  const {
    poContractsUpdateFlowStatus,
    errorMessages,
    resetFlow,
    moveToSummaryStep,
  } = usePoContractsUpdateFlow();

  const renderStatus = () => {
    if (
      poContractsUpdateFlowStatus.update === "error" ||
      poContractsUpdateFlowStatus.upsell === "error"
    ) {
      return (
        <div className="flex flex-col justify-start items-center inline-flex">
          <Link2Off className="h-16 w-16" />
          <div className="flex-col justify-start items-start gap-px inline-flex">
            <div className="self-stretch text-center text-[#08080a] text-2xl font-semibold font-['Inter'] leading-loose">
              Algo deu errado!
            </div>
            <div className="text-center text-zinc-500 text-sm font-normal font-['Inter'] leading-tight">
              Ocorreu um erro durante o processo.
              <br />
              Por favor, verifique sua conexão e tente novamente mais tarde.
            </div>
          </div>
          {(errorMessages.update || errorMessages.upsell) && (
            <Card className="bg-slate-100 text-black max-w-md p-4 my-4 rounded-md">
              <p className="text-sm text-red-500 my-2">
                {errorMessages.update || errorMessages.upsell}
              </p>
            </Card>
          )}
        </div>
      );
    }

    return (
      <div className="flex flex-col justify-start items-center gap-4 inline-flex">
        <CircleCheck className="h-16 w-16" />
        <div className="flex-col justify-start items-center gap-px inline-flex">
          <div className="text-center text-[#08080a] text-2xl font-semibold font-['Inter'] leading-loose">
            Sucesso!
          </div>
          <div className="text-center text-zinc-500 text-sm font-normal font-['Inter'] leading-tight mb-4">
            Seu contrato foi alterado com sucesso!
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] gap-4">
      {renderStatus()}
      {poContractsUpdateFlowStatus.update === "success" && (
        <Button className="gap-2" variant="outline" onClick={() => resetFlow()}>
          <Home className="w-4 h-4" />
          Retornar ao início
        </Button>
      )}
      {(poContractsUpdateFlowStatus.update === "error" ||
        poContractsUpdateFlowStatus.upsell === "error") && (
        <Button
          className="gap-2"
          variant="outline"
          onClick={() => moveToSummaryStep()}
        >
          <Home className="w-4 h-4" />
          Retornar ao contrato
        </Button>
      )}
    </div>
  );
};
